export enum EnumParamAnexoValues {
  FACTURACION_CAPACIDAD_DEMANDA = 'Facturación capacidad demanda',
  FACTURACION_TERMINO_FIJO_CLIENTE = 'Facturación término fijo cliente'
}
